import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import LoadingIndicator from "../../../Common/LoadingIndicator/LoadingIndicator";
import useFeeScheduleCalculatorSection from "../../hooks/useFeeScheduleCalculatorSection";
import { SETTLEMENT_STYLES } from "../../style/styles";

import FeeScheduleAmountCard from "./FeeScheduleAmountCard";
import FeeScheduleChart from "./FeeScheduleChart";
import FeeScheduleUnavailableState from "./FeeScheduleUnavailableState";
import FeeScheduleValueList from "./FeeScheduleValueList";

export default function FeeScheduleCalculatorSection({ className = "" }) {
  const {
    sectionRef,
    values,
    chartColors,
    chartData,
    activeSlice,
    activeIndex,
    activeTooltipPosition,
    isFeeScheduleLoading,
    hoveredSliceName,
    setHoveredSliceName,
  } = useFeeScheduleCalculatorSection();

  return (
    <section
      ref={sectionRef}
      className={`rounded-[12px] p-4 shadow-sm ${className}`}
      style={SETTLEMENT_STYLES.sectionCard}
    >
      <div className="relative flex h-full w-full flex-col gap-4">
        {isFeeScheduleLoading ? (
          <div
            className="absolute inset-0 z-10 flex items-center justify-center rounded-[12px]"
            style={SETTLEMENT_STYLES.loadingOverlay}
          >
            <LoadingIndicator defaultPadding="" />
          </div>
        ) : null}

        <div className="flex items-center gap-3">
          <Svg
            name={SvgEnum.HisCalculator}
            color={SETTLEMENT_STYLES.sectionIconColor}
            sx={SETTLEMENT_STYLES.sectionIcon}
          />
          <h3 className="text-lg font-semibold" style={SETTLEMENT_STYLES.sectionTitle}>
            Fee Schedule Calculator
          </h3>
        </div>

        {values.isFeeScheduleUnavailable ? (
          <FeeScheduleUnavailableState />
        ) : (
          <>
            <div className="grid grid-cols-1 gap-2 md:grid-cols-2">
              <FeeScheduleAmountCard title="Settlement Amount" value={values.settlementAmount} />
              <FeeScheduleAmountCard title="Gross Deductions" value={values.grossDeductions} />
            </div>

            <div className="grid grid-cols-1 gap-4 lg:grid-cols-[minmax(0,1fr)_220px]">
              <FeeScheduleValueList
                values={values}
                chartColors={chartColors}
                activeSliceName={hoveredSliceName}
                onHoverSlice={setHoveredSliceName}
                onLeaveSlice={() => setHoveredSliceName(null)}
              />
              <FeeScheduleChart
                chartData={chartData}
                activeIndex={activeIndex}
                activeSlice={activeSlice}
                activeTooltipPosition={activeTooltipPosition}
                onHoverSlice={setHoveredSliceName}
                onLeaveSlice={() => setHoveredSliceName(null)}
              />
            </div>
          </>
        )}
      </div>
    </section>
  );
}
